import {NumberInput} from '@mantine/core';
import classes from './number-input.module.css';

export const NumberInputTheme = NumberInput.extend({
  classNames: {
    control: classes.control,
  },
});